export const SearchResultsContainer = ({ children }: any) => (
  <div className="bg-primary m-auto text-center">{children}</div>
);
